import { render } from "./SquareButton.vue?vue&type=template&id=1778824c&scoped=true"
import script from "./SquareButton.vue?vue&type=script&lang=js"
export * from "./SquareButton.vue?vue&type=script&lang=js"

import "./SquareButton.vue?vue&type=style&index=0&id=1778824c&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-1778824c"

export default script